import clsx from 'clsx';
import styles from './Kbd.module.css';

/**
 * Tank Redesign Kbd atom — inline keyboard shortcut chip.
 *
 * Source: ~/Downloads/tank-redesign/tokens.jsx → `Kbd` function.
 * Renders a small pill with a subtle border-bottom drop to suggest a key.
 * Use for inline shortcut hints (e.g. "Press <Kbd>D</Kbd> to mark done").
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export default function Kbd({ className, children, ...rest }) {
  return (
    <kbd className={clsx(styles.kbd, className)} {...rest}>
      {children}
    </kbd>
  );
}
